export const receivedPhoneNumber = (state) => state.receivedPhoneNumber;

export const sendDate = (state) => state.sendDate;

export const hasSuccessfullyCreatedAccount = (state) => state.hasSuccessfullyCreatedAccount;

export const customerNumber = (state) => state.customerNumber;
